<template>
  <div>
    <header-page :namePage="$t('pagesTitles.mc')" :links="$store.state.user.segmentM1Distribution ? $store.state.headerLinks.managerMcLinksWithTimetable : $store.state.headerLinks.managerMcLinks"/>
    <modal
      v-show="changeTimeModalVisible"
      @close="closeModal">
      <template #body>
        <div class="modal__content">
          <h2>{{$t('mc.supervisor.timetable.addHours')}}</h2>
          <div class="flex-center modal__time">
            <v-select
              v-if="!isMilitaryTime"
              :clearable="false"
              :searchable="false"
              label="title"
              v-model="startTimeMeridian"
              class="meridian-select"
              :options="options"
              :placeholder="startTimeMeridian"
            />
            <input
              v-mask="'##:##'"
              v-model="newTimeStart"
              class="input-time input-time_timetable"
              type="text"
              placeholder="00:00">
              <div class="dash"></div>
            <input
              v-mask="'##:##'"
              v-model="newTimeEnd"
              class="input-time input-time_timetable"
              type="text"
              placeholder="00:00">
              <v-select
                v-if="!isMilitaryTime"
                :clearable="false"
                :searchable="false"
                label="title"
                v-model="finishTimeMeridian"
                class="meridian-select"
                :options="options"
                :placeholder="finishTimeMeridian"
              />
          </div>
          <div class="flex-center" style="margin-top: 15px; width: 100%">
            <v-select
              :clearable="false"
              :searchable="false"
              class="work-hours-type"
              label="translated_type"
              v-model="weekHourType"
              :options="weekHoursTypes"
            />
          </div>
          <div class="flex-center modal__btn">
            <button class="btn btn_blue"
              :disabled="newTimeStart.length < 5 || newTimeEnd.length < 5"
              @click="addWorkTime">
              {{$t('mc.supervisor.timetable.add')}}
            </button>
          <button
            @click="closeModal"
            class="btn btn--transparent btn_cancel">
            {{$t('mc.supervisor.timetable.cancel')}}
          </button>
          </div>
        </div>
      </template>
    </modal>
    <div class="content">
      <div class="timetable flex">
        <div class="timetable__list-mimk">
          <input class="input timetable__input input-text"
            type="text"
            :placeholder="$t('mc.placeholders.search')"
            v-model="searchedM1"
          />
           <perfect-scrollbar v-if="m1List.length">
              <div class="timetable__choise">
                  <div class="timetable__mimk" v-for="(element) in m1List" :key="element.id">
                  <div class="timetable__person" @click="choiseM1(element)">
                    <span :class="[{'mimk-active': element.active},'timetable__text']">{{element.label}}</span>
                    <div>
                      <inline-svg
                        v-if="element.active"
                        :src="require(`@/assets/svg/check.svg`)"
                      />
                    </div>
                  </div>
                </div>
              </div>
           </perfect-scrollbar>
           <loader v-else></loader>
        </div>
        <loader v-if="isLoader"/>
        <div v-else class="timetable__time">
          <div class="empty-mk-title" v-if="!workWeek.work_week">
          <span>{{$t('mc.placeholders.selectM1FromList')}}</span>
        </div>
        <div v-else>
          <WeekDaysChange
            @changeWeek="changeWeek"
            @updateWeek="updateWeek"
            @removeItem="removeItem"
            :localesTypeOfHour="localesTypeOfHour"
            :week="workWeek.work_week"
            :selectedMimk="selectedM1"
            :currentWeekDays="currentWeekDays"
            :is-m1-schedule="true"
          />
          <button
            class="btn btn_autowidth btn_blue btn_copy"
            @click="duplicateWorkWeekM1">
            {{$t('mc.supervisor.timetable.copy')}}
            </button>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeFilter from '@/helpers/timeValueFilter'
import apiWorkWeeks from '@/api/master-classes/workWeeks'
import WeekDaysChange from '@/components/Supervisor/WeekDaysChange'
import militaryAndLanguage from "@/helpers/militaryAndLanguage"
import en from 'dayjs/locale/en';
import apiM1 from "@/api/master-classes/m1";
export default {
  data() {
    return {
      weekHourType: {},
      militaryAndLanguage,
      startTimeMeridian: 'am',
      finishTimeMeridian: 'am',
      options: [
        'am',
        'pm'
      ],
      timeFilter,
      isLoader: true,
      changeTimeModalVisible: false,
      childArgObj: {},
      newTimeStart: '',
      newTimeEnd: '',
      searchedM1: '',
      currentM1: {},
      selectedM1: {},
      currentWeekDays: {
        firstday: '',
        lastday: '',
      },
      workWeek: {},
      weekHoursTypes: [],
      localesTypeOfHour: {},
    }
  },
  components: {
    WeekDaysChange
  },
  created() {
    this.getM1List()
    this.fetchHourTypes()
    this.$dayjs.locale({
    ...en,
    weekStart: 1
    })
    //Находим первый и послдений день текущией недели и присваиваем в  this.currentWeekDays
    this.currentWeekDays.firstday = this.$dayjs().weekday(0).format('YYYY-MM-DD')
    this.currentWeekDays.lastday = this.$dayjs().weekday(0).add(6, 'day').format('YYYY-MM-DD')
    this.isLoader = false
  },
  beforeDestroy() {
    //когда дестроим компонент удаляем флаг активности у всего списка мимков
    this.m1List.forEach(element => {
      if (element.active) {
        element.active = false
      }
    })
  },
  computed: {
    isMilitaryTime() {
      let military = null
      military = this.militaryAndLanguage()
      return military
    },
    //Фильтруем список мимков по тому,что пользователь ввел в инпут поисковика
    m1List() {
      let object = this.$store.state.user.m1List.filter((element) => {
        return (element.label.toLowerCase().trim().indexOf(this.searchedM1.toLowerCase().trim()) != -1 )
      });
      return object;
    },
  },
  methods: {
    fetchHourTypes() {
      apiWorkWeeks.getWorkHoursTypesM1().then(types => {
        types = types.filter(item => item.key !== 'Проведение уроков')

        this.weekHoursTypes = [...this.weekHoursTypes, ...types]
        this.weekHourType = { key: this.weekHoursTypes[0].key, translated_type: this.weekHoursTypes[0].translated_type }
        const localeObject = {}
        types.forEach(type => { localeObject[type.key] = type.translated_type })
        this.localesTypeOfHour = localeObject
      })
    },

    getM1List() {
      apiM1.getM1Status().then(listM1 => {
        this.$store.commit("user/setM1List", listM1)
      });
    },
    //Метод копирования текущего выбранного распиания МИМКа на следующую неделю
    async duplicateWorkWeekM1() {
      //Копируем текущее расписание и преобразовываем данные для отправки на сервер
      let daysInWeek = JSON.parse(JSON.stringify(this.workWeek.work_week))
        daysInWeek.forEach(day => {
          delete day.name_translated
          day.work_hours.forEach(el => {
            el.tz_offset = this.$store.state.user.segment.tz_offset
          })
          if (day.work_hours.length) {
            const date = day.date
            for (let hour in day.work_hours) {
              if (day.work_hours[hour].work_ends_at && day.work_hours[hour].work_starts_at) {
                if (!this.isMilitaryTime) {
                  day.work_hours[hour].work_ends_at = `${date} ${this.$dayjs(day.work_hours[hour].work_ends_at, 'hh:mm a').format('HH:mm')}`
                  day.work_hours[hour].work_starts_at = `${date} ${this.$dayjs(day.work_hours[hour].work_starts_at, 'hh:mm a').format('HH:mm')}`
                }else {
                  day.work_hours[hour].work_ends_at = `${date} ${day.work_hours[hour].work_ends_at}`
                  day.work_hours[hour].work_starts_at = `${date} ${day.work_hours[hour].work_starts_at}`
                }
              }
            }
          }
        })
        // Функция копирования расписания на следующую неделю
        await apiWorkWeeks.duplicateWorkWeekM1(
          this.workWeek._id,
          this.workWeek.m1,
          this.selectedM1.m1_name,
          this.selectedM1.rating,
          this.$dayjs(this.currentWeekDays.firstday).format('YYYY-MM-DD'),
          this.$dayjs(this.currentWeekDays.lastday).format('YYYY-MM-DD'),
          daysInWeek
        )
    },
    //Метод вызываемый при выборе предыдущей или следующей недели
    async changeWeek(isNext) {
       //Если пользователь выбирает следующую неделю передаем параметр isNext Далее в зависимости от параметра вычитаемили прибавляем дни
      if (isNext) {
        this.currentWeekDays.firstday = this.$dayjs(this.currentWeekDays.firstday).add(7, 'day').format('YYYY-MM-DD')
        this.currentWeekDays.lastday = this.$dayjs(this.currentWeekDays.firstday).add(6, 'day').format('YYYY-MM-DD')
      }else {
        this.currentWeekDays.firstday = this.$dayjs(this.currentWeekDays.firstday).subtract(7, 'day').format('YYYY-MM-DD')
        this.currentWeekDays.lastday = this.$dayjs(this.currentWeekDays.lastday).subtract(7, 'day').format('YYYY-MM-DD')
      }
        this.isLoader = true
        //Получаем данные для выбранной недели
        const week = await apiWorkWeeks.getWorkWeeksM1(
        this.currentM1.id,
        this.currentWeekDays.firstday,
        this.currentWeekDays.lastday
        )
        this.workWeek = week
        this.isLoader = false
    },
    async mutateDateItem(data, addTime) {
      //Сравнение и проверка, на то, что конечное время позднее предыдущего
      if (!this.isMilitaryTime) {
        this.newTimeStart = this.$dayjs(`${this.newTimeStart} ${this.startTimeMeridian}`, 'hh:mm a').format('HH:mm')
        this.newTimeEnd = this.$dayjs(`${this.newTimeEnd} ${this.finishTimeMeridian}`, 'hh:mm a').format('HH:mm')
      }
      const timeDifference = this.$dayjs(this.newTimeEnd, 'HH:mm').diff(this.$dayjs(this.newTimeStart, 'HH:mm'), 'minute')
      if (timeDifference <= 0) {
        this.$toasted.global.all_mistake('Начальное время не должно быть позднее конечного')
        //Остававливаем выполнение addWorkTime
        return false
      }
      //Объект в временем для отправки на сервер
      const newFetchTimeObject = {
        work_starts_at:`${this.childArgObj.date} ${this.newTimeStart}`,
        work_ends_at: `${this.childArgObj.date} ${this.newTimeEnd}`,
        is_admin_hours: !!this.weekHourType.key
      }
      if (this.weekHourType.key) {
        newFetchTimeObject.type_of_hours = this.weekHourType.key ? this.weekHourType.key : null
      }
      //Формируем правильный формат рабочей недели для отправки на сервер
        data.forEach(day => {
        if (day.work_hours.length) {
          const date = day.date
          // let formatTime = this.isMilitaryTime ? 'HH:mm' : 'hh:mm a'
          for (let hour in day.work_hours) {
            if (day.work_hours[hour].work_ends_at && day.work_hours[hour].work_starts_at) {
              if (!this.isMilitaryTime) {
                day.work_hours[hour].work_ends_at = `${date} ${this.$dayjs(day.work_hours[hour].work_ends_at, 'hh:mm a').format('HH:mm')}`
                day.work_hours[hour].work_starts_at = `${date} ${this.$dayjs(day.work_hours[hour].work_starts_at, 'hh:mm a').format('HH:mm')}`
              }else {
                day.work_hours[hour].work_ends_at = `${date} ${day.work_hours[hour].work_ends_at}`
                day.work_hours[hour].work_starts_at = `${date} ${day.work_hours[hour].work_starts_at}`
              }
            }
          }
        }
      })
      //Если мы используем метод для добавления времени то ...
      if (addTime) {
        //Создаем переменную repeatTime, далее мы будем сравнивать пересечения по времени, если repeatTime будет true, значит добавляемое время пересекается с уже существующим
        let repeatTime = false
        const compareHours = (currentHour, newHour) => this.$dayjs(currentHour).diff(this.$dayjs(newHour), 'minute')
        data[this.childArgObj.indexDay].work_hours.forEach((element,i) => {
          //Логика такая, что если в одном сравниваемых массивах firstCompareArray и secondCompareArray будет одно положительное и однои отрицательное число, значит мы имеем пересечение, если оба числа положительные или отрицательные, значит пересечения нет
          if (this.childArgObj.indexTime !== i){
            const firstStartCompare = compareHours(element.work_starts_at, newFetchTimeObject.work_starts_at)
            const firstEndCompare = compareHours(element.work_ends_at, newFetchTimeObject.work_starts_at)
            const secondStartCompare = compareHours(element.work_starts_at, newFetchTimeObject.work_ends_at)
            const secondEndCompare = compareHours(element.work_ends_at, newFetchTimeObject.work_ends_at)

            const firstValidCase = firstStartCompare > 0 && secondStartCompare >= 0
            const secondValidCase = firstEndCompare <= 0 && secondEndCompare < 0

            const isDateInvalid = !(firstValidCase || secondValidCase)

            if (isDateInvalid) repeatTime = true

            // fix on equal end and start in different slots
            // if ((firstStartCompare >= 0 && firstEndCompare < 0) ||
            //   (secondStartCompare >= 0 && secondEndCompare <= 0) ||
            //   (firstStartCompare <= 0 && firstEndCompare >= 0) ||
            //   (secondStartCompare <= 0 && secondEndCompare >= 0)) repeatTime = true
          }
        })
        //Если нет пересечения, то добавляем время в массив с рабочим днем по индексу получаемому из эмита updateWeek
        if (!repeatTime) {
          if (this.childArgObj.time) data[this.childArgObj.indexDay].work_hours[this.childArgObj.indexTime] = newFetchTimeObject
          else  data[this.childArgObj.indexDay].work_hours.push(newFetchTimeObject)
        }
        //Если пересечение есть остававливаем выполнение addWorkTime, оповещаем пользователя
        else {
          this.$toasted.global.all_mistake(this.$t('mc.toasts.conflictTimes'))
          return
        }
      }
      data.forEach(day => {
        delete day.name_translated
        day.work_hours.forEach(el => {
          el.tz_offset = this.$store.state.user.segment.tz_offset
        })
      })
      this.isLoader = true
      //Отправляем запрос на изменение рабочей недели.
      await apiWorkWeeks.changeWorkWeeksM1(
        this.workWeek._id,
        this.workWeek.m1,
        this.selectedM1.m1_name,
        this.selectedM1.rating,
        this.$dayjs(this.currentWeekDays.firstday).format('YYYY-MM-DD'),
        this.$dayjs(this.currentWeekDays.lastday).format('YYYY-MM-DD'),
        data,
        addTime
      )
      return true
    },
    //Метод удаления рабочего времени из расписания, принцип работы аналогичен добавлению описанному в addWorkTime
    async removeItem(newWeekData) {
      let daysInWeek = JSON.parse(JSON.stringify(newWeekData))
      await this.mutateDateItem(daysInWeek)
      this.workWeek = await apiWorkWeeks.getWorkWeeksM1(
        this.selected1.m1,
        this.currentWeekDays.firstday,
        this.currentWeekDays.lastday
      )
      this.isLoader = false
    },
    closeModal() {
      this.changeTimeModalVisible = false
      this.newTimeStart = ''
      this.newTimeEnd = ''
      this.weekHourType = { key: this.weekHoursTypes[0].key, translated_type: this.weekHoursTypes[0].translated_type }
      this.startTimeMeridian = 'am'
      this.finishTimeMeridian = 'am'
    },
    //Метод добавление рабочих часов МИМКа в расписание
    async addWorkTime() {
      //Копируем рабочую неделю
      let daysInWeek = JSON.parse(JSON.stringify(this.workWeek.work_week))
      //Функция добавление часов в расписание, присваиваем в переменную, чтобы потом проверить содержиться ли уже такое время в расписании
      const isTimeIndeed = await this.mutateDateItem(daysInWeek, true)
      if (!isTimeIndeed) {
        return
      }
      //получаем измененную рабочую неделю
      this.workWeek = await apiWorkWeeks.getWorkWeeksM1(
      this.selectedM1.m1,
      this.currentWeekDays.firstday,
      this.currentWeekDays.lastday
      )
      this.isLoader = false
      this.closeModal()
    },
    updateWeek(arg) {
      this.childArgObj = arg
      //Эмит в котором принимаем индекс и дату рабочего дня
      if (this.childArgObj.time) {
        this.newTimeStart = this.childArgObj.time.work_starts_at
        this.newTimeEnd = this.childArgObj.time.work_ends_at
        if (this.childArgObj.time.is_admin_hours) {
          this.weekHourType = this.weekHoursTypes.find(item => item.key === this.childArgObj.time.type_of_hours)
        }
        if (!this.isMilitaryTime) {
          this.startTimeMeridian = this.childArgObj.time.work_starts_at.slice(-3)
          this.finishTimeMeridian = this.childArgObj.time.work_ends_at.slice(-3)
        }
      }
      this.changeTimeModalVisible = true
    },
    //Метод срабатываемый при выборе МИМКа
    async choiseM1(m1) {
      console.log(m1)
      this.currentM1 = m1
      this.m1List.forEach(element => {
        if (element.active) {
         element.active = false
        }
      })
      this.selectedM1 = {
        m1: this.currentM1.id,
        m1_name: this.currentM1.label,
        rating: this.currentM1.rating
      }
      this.isLoader = true
      //Отправка запроса на получение расписания МИМКа
      const week = await apiWorkWeeks.getWorkWeeksM1(
      this.currentM1.id,
      this.currentWeekDays.firstday,
      this.currentWeekDays.lastday
      )
      //Присваиваем расписание в this.workWeek
      this.workWeek = week
      m1.active = true
      this.isLoader = false
    },
  },
  watch: {
    //При изменении времени в инпутах, наблюдаем за корректным заполнением инпута пользователем через функцию timeFilter
    newTimeStart(val) {
      this.newTimeStart = this.timeFilter(val, this.newTimeStart)
    },
    newTimeEnd(val) {
      this.newTimeEnd = this.timeFilter(val, this.newTimeEnd)
    }
  }
}
</script>
<style lang="scss">
.work-hours-type .vs__dropdown-menu {
  position: absolute;
  left: 160px;
  top: -100px;
}
</style>
<style lang="scss" scoped>
.work-hours-type {
  z-index: 100;
  min-width: 160px;
}
.meridian-select {
  max-width: 65px;
  min-width: 65px;
}
.meridian-select::v-deep {
    & .vs__dropdown-toggle{
     height: 40px;
    }
    & .vs__dropdown-menu {
      min-width: 0;
    }
  }
.input-time_timetable {
  margin: 0 10px;
}
.btn_copy {
  margin: 0 auto;
  margin-top: 30px;
}
.modal {
  &__content {
    text-align: center;
  }
  &__time {
    align-items: center;
    margin-top: 30px;
  }
  &__btn {
    margin-top: 30px;
  }
}
.dash {
  width: 8px;
  height: 1px;
  background: #808080;
}
.ps {
  height: calc(100% - 80px);
}
.timetable {
  &__input {
    display: block;
    width: 234px;
    margin: 0 auto;
    margin-bottom: 18px;
  }
  &__choise {
    padding-left: 30px;
  }
  &__list-mimk {
    padding: 17px 17px;
    height: calc(100vh - 110px);
    background: #FFFFFF;
    margin-right: 20px;
  }
  &__time {
    padding: 48px 25px 85px 25px;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
  }
  &__mimk {
    white-space: nowrap;
    display: flex;
    margin-bottom: 18px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__person {
    cursor: pointer;
    display: flex;
    // width: 200px;
  }
  &__week-change {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__week-toggler {
    font-size: 18px;
    cursor: pointer;
    color: #315AF2;
  }
  &__text {
    margin-right: 20px;
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
    color: #010101;
  }
}
.mimk-active {
  color: #315AF2;
}

</style>
